import Endpoint from "../Endpoint";

class Tags extends Endpoint {
    buildUrl({ param }) {
        return ['tags', param];
    }
}

export default new Tags;